import {
  PaymentLineItem,
  PaymentLineItemTypeEnum,
  PaymentRequestNotificationData,
} from "@cruisen/contract"
import styles from "./styles.module.scss"
import PaymentRequestImage from "../../../../assets/paymentRequest.png"
import { _t, formatCurrency } from "@cruisen/i18n"
import classNames from "classnames"

const BasicPaymentLineItem = ({ item }: { item: PaymentLineItem }) => {
  return (
    <div className={styles.basicPaymentLineItem}>
      {item.label && <p className={styles.label}>{item.label}</p>}
      {item.description && <p className={styles.description}>{item.description}</p>}
      <div className={styles.row}>
        <p className={styles.label}>
          {_t("navigatorSystemMessageComponents.paymentRequest.amount")}
        </p>
        <p className={styles.value}>{formatCurrency(Number(item.amount), 2)}</p>
      </div>
      {item.deposit && (
        <div className={styles.row}>
          <p className={styles.label}>
            {_t("navigatorSystemMessageComponents.paymentRequest.depositAmount")}
          </p>
          <p className={styles.value}>{formatCurrency(Number(item.deposit), 2)}</p>
        </div>
      )}
      <div className={styles.row}>
        <p className={classNames(styles.label, styles.totalPrice)}>
          {_t("navigatorSystemMessageComponents.paymentRequest.totalAmount")}
        </p>
        <p className={classNames(styles.value, styles.totalPrice)}>
          {formatCurrency(Number(item.total), 2)}
        </p>
      </div>
    </div>
  )
}

const CabinBookingLineItem = ({ item }: { item: PaymentLineItem }) => {
  const meta = item.meta as { deckName?: string; cabinNo?: string }

  return (
    <div className={styles.cabinBookingLineItem}>
      {meta.deckName && meta.cabinNo ? (
        <div className={styles.row}>
          <p className={styles.label}>Deck · Cabin</p>
          <p className={styles.value}>
            {meta.deckName} · {meta.cabinNo}
          </p>
        </div>
      ) : null}
      {item.deposit && (
        <div className={styles.row}>
          <p className={styles.label}>Deposit amount</p>
          <p className={styles.value}>{formatCurrency(Number(item.deposit), 2)}</p>
        </div>
      )}
      {item.totalDueDate && (
        <div className={styles.row}>
          <p className={styles.label}>Total due date</p>
          <p className={styles.value}>{new Date(item.totalDueDate).toLocaleDateString()}</p>
        </div>
      )}
      <div className={styles.divider}></div>
      <div className={styles.row}>
        <p className={styles.label}>Cabin fare</p>
        <p className={styles.value}>{formatCurrency(Number(item.amount), 2)}</p>
      </div>
      {Number(item.taxesAndFees || 0) > 0 ? (
        <div className={styles.row}>
          <p className={styles.label}>Taxes & fees</p>
          <p className={styles.value}>{formatCurrency(Number(item.taxesAndFees || 0), 2)}</p>
        </div>
      ) : null}
      <div className={styles.row}>
        <p className={classNames(styles.label, styles.totalPrice)}>Total amount:</p>
        <p className={classNames(styles.value, styles.totalPrice)}>
          {formatCurrency(Number(item.total), 2)}
        </p>
      </div>
    </div>
  )
}

export const PaymentRequestMessage = ({
  data,
  openPaymentRequestDetails,
}: {
  data: PaymentRequestNotificationData
  openPaymentRequestDetails: () => void
}) => {
  const { paymentRequest } = data

  return (
    <div className={styles.paymentRequest} data-testid="payment-request-message">
      <div className={styles.header}>
        <img className={styles.headerImage} src={PaymentRequestImage} alt="Quote" />
      </div>
      <div className={styles.body}>
        <p className={styles.quoteMessage}>{`New quote "${paymentRequest.label}"`}</p>
        {paymentRequest.lineItems.map((item, index) => (
          <div key={item.id}>
            <div className={styles.divider}></div>
            <div>
              {item.type === PaymentLineItemTypeEnum.CabinBooking ? (
                <CabinBookingLineItem item={item} />
              ) : (
                <BasicPaymentLineItem item={item} />
              )}
              {index < paymentRequest.lineItems.length - 1 && (
                <div className={styles.divider}></div>
              )}
            </div>
          </div>
        ))}
        <button
          data-testid="payment-request-message-view-details-button"
          className={styles.viewDetailsButton}
          onClick={openPaymentRequestDetails}
        >
          View details
        </button>
      </div>
    </div>
  )
}
